<template>
  <a-layout class="index animated fadeIn">
    <a-card>
      <SmallSquare content="用于管理码包下载设备的授权、启停与密钥。" class="m-b-10" />
      <!-- 筛选区：字段与列表接口 query 对齐 -->
      <a-form
        ref="form"
        :model="search"
        :style="{ marginBottom: '20px' }"
        :initialValues="search"
        :onFinish="pageSearchChange"
        layout="inline"
      >
        <a-form-item label="设备号" name="device_mark">
          <a-input
            v-model:value="search.device_mark"
            style="width: 180px"
            placeholder="请输入设备号"
            allowClear
          />
        </a-form-item>
        <a-form-item label="品牌ID" name="brand_id">
          <a-input
            v-model:value="search.brand_id"
            style="width: 160px"
            placeholder="请输入品牌ID"
            allowClear
          />
        </a-form-item>
        <a-form-item label="是否允许下载" name="allow_download">
          <a-select
            v-model:value="search.allow_download"
            style="width: 140px"
            placeholder="全部"
            allowClear
          >
            <a-select-option :value="1">允许</a-select-option>
            <a-select-option :value="0">禁用</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="创建时间" name="time">
          <a-range-picker
            v-model:value="search.time"
            valueFormat="YYYY-MM-DD"
            format="YYYY-MM-DD"
            @change="onTimeChange"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType="submit">搜索</a-button>
          <a-button
            type="primary"
            class="m-l-10"
            v-has:codeDownloadDeviceCreate="() => goForm('add')"
          >
            新增
          </a-button>
        </a-form-item>
      </a-form>

      <!-- 列表：列与接口返回字段对齐 -->
      <a-table
        :pagination="false"
        :loading="listLoading"
        bordered
        rowKey="id"
        :columns="columns"
        :data-source="data"
        class="tableFixBox"
        :scroll="{ x: 'max-content' }"
      >
        <!-- 启用/禁用 -->
        <template v-slot:allow_download="{ record }">
          <a-switch
            :checked="record.allow_download === 1"
            checked-children="启用"
            un-checked-children="禁用"
            v-authAction:codeDownloadDeviceStatus="() => onStatusChange(record)"
          />
        </template>
        <template v-slot:action="{ record }">
          <a
            v-has:codeDownloadDeviceDetail="() => goForm('detail', record)"
            href="javascript:;"
            class="m-r-20"
          >
            详情
          </a>
          <a
            v-has:codeDownloadDeviceUpdate="() => goForm('edit', record)"
            href="javascript:;"
            class="m-r-20"
          >
            编辑
          </a>
          <a
            v-has:codeDownloadDeviceResetSecret="() => onResetSecret(record)"
            href="javascript:;"
            class="m-r-20"
          >
            重置密钥
          </a>
          <a
            v-has:codeDownloadDeviceDelete="() => onDelete(record)"
            href="javascript:;"
            style="color: #ff4d4f"
          >
            删除
          </a>
        </template>
      </a-table>
      <a-pagination
        :style="{ marginTop: '20px', textAlign: 'right' }"
        show-size-changer
        show-quick-jumper
        :current="search.page"
        :page-size="search.limit"
        :total="total"
        @change="pageCurrentChange"
        @showSizeChange="pageSizeChange"
        :show-total="(total) => `总数: ${total} `"
      />
    </a-card>

    <!-- 密钥仅展示一次 -->
    <a-modal
      v-model:visible="secretVisible"
      title="设备密钥（请立即保存）"
      :footer="null"
      centered
      :width="560"
    >
      <a-alert
        type="warning"
        show-icon
        message="密钥仅本次展示，关闭后无法再次查看，请立即复制并妥善保存。"
        class="m-b-15"
      />
      <a-typography-paragraph copyable :content="secretValue" />
      <div class="s_flex_center">
        <a-button type="primary" @click="secretVisible = false">我已保存</a-button>
      </div>
    </a-modal>
  </a-layout>
</template>
<script>
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message, Modal } from "ant-design-vue";
import { $iscode } from "@/utils/app";
import {
  codeWrapDeviceList,
  codeWrapDeviceStatus,
  codeWrapDeviceDelete,
  codeWrapDeviceResetSecret
} from "@/api/codeWrap";

// 列表默认筛选项
let defSearch = {
  device_mark: "",
  brand_id: "",
  allow_download: undefined,
  time: [],
  start_time: "",
  end_time: "",
  page: 1,
  limit: 10
};

export default {
  setup() {
    const $router = inject("$router");
    let search = ref({ ...defSearch });
    let data = ref([]);
    const state = reactive({
      listLoading: false,
      total: 0,
      secretVisible: false,
      secretValue: ""
    });

    // 表格列配置（字段名与接口返回一致）
    let columns = [
      { title: "ID", dataIndex: "id", key: "id", width: 80 },
      { title: "品牌名称", dataIndex: "brand_name", key: "brand_name" },
      { title: "设备号", dataIndex: "device_mark", key: "device_mark" },
      { title: "设备名", dataIndex: "device_name", key: "device_name" },
      {
        title: "允许下载",
        dataIndex: "allow_download",
        key: "allow_download",
        slots: { customRender: "allow_download" }
      },
      { title: "创建时间", dataIndex: "created_at", key: "created_at" },
      { title: "更新时间", dataIndex: "updated_at", key: "updated_at" },
      {
        title: "操作",
        key: "action",
        width: 280,
        fixed: "right",
        slots: { customRender: "action" }
      }
    ];

    // 时间范围变化，映射到 start_time / end_time
    const onTimeChange = (dates) => {
      if (dates && dates.length === 2) {
        search.value.start_time = dates[0];
        search.value.end_time = dates[1];
      } else {
        search.value.start_time = "";
        search.value.end_time = "";
      }
    };

    // 组装查询参数，去掉空值，避免多余 query
    const buildParams = () => {
      const { time, allow_download, brand_id, ...rest } = search.value;
      const params = { ...rest };
      if (allow_download === 0 || allow_download === 1) {
        params.allow_download = allow_download;
      }
      if (brand_id !== "" && brand_id !== null && brand_id !== undefined) {
        params.brand_id = brand_id;
      }
      return params;
    };

    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData();
    };
    const pageCurrentChange = (page) => {
      search.value.page = page;
      initData();
    };
    const pageSizeChange = (current, size) => {
      search.value.page = 1;
      search.value.limit = size;
      initData();
    };

    // 拉取列表
    const initData = async () => {
      state.listLoading = true;
      data.value = [];
      try {
        let res = await codeWrapDeviceList(buildParams()).then((res) => res.data);
        state.listLoading = false;
        if ($iscode(res)) {
          // 接口返回的 allow_download 可能是字符串数字，统一转 Number
          data.value = (res.data.data || []).map((item) => ({
            ...item,
            allow_download: Number(item.allow_download)
          }));
          state.total = res.data.total || 0;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };

    // 跳转新增 / 编辑 / 详情（三个独立路径，共用 create.vue）
    const goForm = (mode, record) => {
      // 路径 key 对应后台菜单；component 均为 codeManage/codeWrap/create
      const pathMap = {
        add: "/codeManage/codeWrap/create",
        edit: "/codeManage/codeWrap/edit",
        detail: "/codeManage/codeWrap/detail"
      };
      const query = {};
      if (record) query.id = record.id;
      $router.push({ path: pathMap[mode] || pathMap.add, query });
    };

    // 启用 / 禁用（反选后提交）
    const onStatusChange = async (record) => {
      const next = record.allow_download === 1 ? 0 : 1;
      let res = await codeWrapDeviceStatus(record.id, next).then((res) => res.data);
      if ($iscode(res, true)) {
        initData();
      }
    };

    // 删除（二次确认）
    const onDelete = (record) => {
      Modal.confirm({
        title: "删除确认",
        content: `确定删除设备「${record.device_mark}」吗？删除后不可在列表中查看。`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          let res = await codeWrapDeviceDelete(record.id).then((res) => res.data);
          if ($iscode(res, true)) {
            initData();
          }
        }
      });
    };

    // 从响应中提取密钥（兼容对象 / 数组）
    const pickSecret = (payload) => {
      if (!payload) return "";
      if (typeof payload === "string") return payload;
      if (payload.device_secret) return payload.device_secret;
      if (Array.isArray(payload) && payload[0]) {
        return payload[0].device_secret || "";
      }
      return "";
    };

    // 重置密钥：强制流程确认后提交，并仅一次展示新密钥
    const onResetSecret = (record) => {
      Modal.confirm({
        title: "重置设备密钥",
        width: 560,
        content:
          "重置后在线设备会立即验签失败（掉线）。请按以下顺序操作：\n" +
          "1. 先禁用设备\n" +
          "2. 通知产线端停止下载任务\n" +
          "3. 执行重置密钥\n" +
          "4. 通过安全渠道下发新密钥\n" +
          "5. 产线端配置新密钥并重启下载\n" +
          "6. 重新启用设备\n" +
          "确定继续重置吗？",
        okText: "确定重置",
        okType: "danger",
        cancelText: "取消",
        onOk: async () => {
          let res = await codeWrapDeviceResetSecret(record.id).then((res) => res.data);
          if ($iscode(res, true)) {
            const secret = pickSecret(res.data);
            state.secretValue = secret || "（接口未返回密钥，请联系管理员）";
            state.secretVisible = true;
            initData();
          }
        }
      });
    };

    onMounted(() => {
      initData();
    });

    return {
      ...toRefs(state),
      search,
      data,
      columns,
      onTimeChange,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      goForm,
      onStatusChange,
      onDelete,
      onResetSecret
    };
  }
};
</script>
